export var decode = function (str) {
  return global.atob(str);
};